export const Hospitals: any[] = [
  {
    name: 'Hospital del Norte',
    location: {
      address: 'Av. Urpila',
      coords: {
        lat: '-17.348682200307536',
        lng: '-66.17471004777057'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipON8kM3SKuuuvOSeH0UiZnigOjTrlR3OxCFtKtW=w408-h306-k-no'
  },
  {
    name: 'Hospital Cochabamba',
    location: {
      address: 'C. Nataniel Aguirre y I.Montes',
      coords: {
        lat: '-17.400405862407208',
        lng: '-66.15609421193842'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipOruHBAiYwbqWDQQA5HegHCkEpkCaLCSmBCB93y=w408-h306-k-no'
  },
  {
    name: 'Clínica Los Olivos',
    location: {
      address: 'Av. Melchor Pérez de Olguín',
      coords: {
        lat: '-17.389300222542794',
        lng: '-66.1796174603923'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipNlF92LqVqnjLqvqGYzoxvrXwRbYuEP3PbzA2eb=w408-h408-k-no'
  },
  {
    name: 'Hospital Harry Williams',
    location: {
      address: 'Av. República de Suecia 1038',
      coords: {
        lat: '-17.419725393185924',
        lng: '-66.14694929666942'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipNENTCQEVPsvA2O67G9YqUr7AF0hnvyrEeclnH2=w408-h306-k-no'
  },
  {
    name: 'Hospital Univalle Sud',
    location: {
      address: 'C. Acacias y C. Amboro',
      coords: {
        lat: '-17.421216148779283',
        lng: '-66.13289702306076'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipM6JlKW4_tV_ActjinVgPLkJ0FWDuAXfJB7tqwD=w408-h306-k-no'
  },
  {
    name: 'Hospital del Sud',
    location: {
      address: 'C. Volcán Tolima',
      coords: {
        lat: '-17.450187508689098',
        lng: '-66.14991178508332'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipNYWSyohI8bT-Yg_bwlpEitjpjeGVUqhca5aF8z=w408-h306-k-no'
  },
  {
    name: 'Seguro Social Universitario Cochabamba',
    location: {
      address: 'Av. Aniceto Arce 374',
      coords: {
        lat: '-17.38787001651189',
        lng: '-66.14814628411159'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipNbmfGZ1ul6yWaOfR4eNwatog8WEj9z4ozG7eA2=w408-h544-k-no'
  },
  {
    name: 'Clínica San Pedro',
    location: {
      address: 'C. Aurelio Melean',
      coords: {
        lat: '-17.391193021455738',
        lng: '-66.14785603275911'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipNenxvCzCKqUBW-R98ZIDjA_3qpT1OxPqApkEvl=w426-h240-k-no'
  },
  {
    name: 'Hospital Viedma',
    location: {
      address: 'C. Venezuela',
      coords: {
        lat: '-17.385428956122702',
        lng: '-66.14862798712443'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipMC8FSbkvWKrtdNLP27Ywlcdqz9OPxugnSI-iKN=w426-h240-k-no'
  },
  {
    name: 'Hospital German Urquidi',
    location: {
      address: 'Av. Aniceto Arce',
      coords: {
        lat: '-17.386927833682183',
        lng: '-66.14905093926009'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipOsaNvk8pf4CLlNXZBp0f34s-q0w3ljUwc8M_O0=w426-h240-k-no'
  },
  {
    name: 'Hospital Materno Infantil',
    location: {
      address: 'C. Germán Urquidi',
      coords: {
        lat: '-17.38635695149174',
        lng: '-66.14828927744256'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipPXPYIStsPiDWbTH6__05AYyYQHX-k4C0qmrref=w408-h544-k-no'
  },
  {
    name: 'Instituto Gastroenteroligico',
    location: {
      address: 'C. Venezuela',
      coords: {
        lat: '-17.386294124532878',
        lng: '-66.14943760332184'
      }
    },
    photo: 'https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid=tsxnmLzTQl8hFLHyK7xbrA&cb_client=search.gws-prod.gps&w=408&h=240&yaw=140.45757&pitch=0&thumbfov=100'
  },
  {
    name: 'Hospital Aranjuez',
    location: {
      address: 'C. 16 de Julio',
      coords: {
        lat: '-17.382142095742466',
        lng: '-66.15347478770182'
      }
    },
    photo: 'https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid=taRPD2d8cznfBTk_i2CMRg&cb_client=search.gws-prod.gps&w=408&h=240&yaw=34.35103&pitch=0&thumbfov=100'
  },
  {
    name: 'Hospital Belga',
    location: {
      address: 'C. Antezana',
      coords: {
        lat: '-17.38721466995335',
        lng: '-66.15316459381715'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipN1aL40dFz6WORYMuBPHR_0_eMBDWthg-yVklmA=w408-h277-k-no'
  },
  {
    name: 'Hospital San Vicente',
    location: {
      address: 'C. Baptista',
      coords: {
        lat: '-17.387664676694573',
        lng: '-66.15872700880647'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipOBR2OFhxsac48KQuWV8-q4RlH8_HAwc1I8JfZS=w426-h240-k-no'
  },
  {
    name: 'Clínica Los Ángeles',
    location: {
      address: 'Av. Juan de la Rosa',
      coords: {
        lat: '-17.378765276902172',
        lng: '-66.16446930977618'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipOB_O5vPBAKZzM0Eazg0jgviaoksUfCqi1SpW1I=w648-h240-k-no'
  },
  {
    name: 'Hospital Infantil Albina Patiño',
    location: {
      address: 'Av Oquendo',
      coords: {
        lat: '-17.3945690724275',
        lng: '-66.14974484538348'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipPtt5eatThIqDwY_0DjHF02lSPTsap6DKD_ZdGY=w408-h306-k-no'
  },
  {
    name: 'COSSMIL',
    location: {
      address: 'Av. Ramón Rivero',
      coords: {
        lat: '-17.37936082381973',
        lng: '-66.14488629022537'
      }
    },
    photo: 'https://lh5.googleusercontent.com/p/AF1QipNvPc4HYz0j98l69QO-jqauy74FxFWMwqhT_-0b=w408-h307-k-no'
  }
]